<template>
  <div class="centuries-slider flex flex-col justify-end px-9">
    <Slider
      :min="min"
      :max="max"
      :options="options"
      :value="valueComputed"
      :tooltip-placement="'top'"
      :tooltips="isTimeline"
      @change="emitValue($event)"
    >
    </Slider>
  </div>
</template>

<script setup>
import Slider from '@vueform/slider';
const props = defineProps({
  startCentury: {
    type: [Number, String],
    default: 0,
  },
  endCentury: {
    type: [Number, String],
    default: 0,
  },
  value: {
    type: Object,
    default: () => ({}),
  },
  isTimeline: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['on-century-change']);

const options = computed(() => {
  return {
    enableCross: false,
    dotSize: [9, 17],
    width: 'auto',
    height: 4,
    interval: 1,
    lazy: true,
    silent: true,
    ...(!props.isTimeline && {
      range: {
        min: [min.value],
        max: [max.value],
      },
    }),
    ...(!props.isTimeline && {
      pips: {
        mode: 'count',
        values: valuesPips.value,
        density: 1,
      },
    }),
  };
});

const min = computed(() => (props.isTimeline ? props.value.range_start : 9));
const max = computed(() => (props.isTimeline ? props.value.range_end : 21));

const valuesPips = computed(() => max.value - min.value + 1);

const valueComputed = computed(() => {
  return props.isTimeline
    ? [props.value.start_year, props.value.end_year]
    : [+props.startCentury, +props.endCentury];
});

const emitValue = (val) => {
  emit('on-century-change', val);
};
</script>

<style src="@vueform/slider/themes/default.css"></style>

<style lang="scss">
:root {
  --slider-bg: #e3b3b5;
  --slider-connect-bg: #a10009;
  --slider-connect-bg-disabled: #9ca3af;
  --slider-height: 4px;
  --slider-vertical-height: 300px;
  --slider-radius: 0;

  --slider-handle-bg: #a10009;
  --slider-handle-border: 0;
  --slider-handle-width: 18px;
  --slider-handle-height: 18px;
  --slider-handle-radius: 9999px;
  --slider-handle-shadow: #00000000;
  --slider-handle-shadow-active: #00000000;
  --slider-handle-ring-width: 3px;
  --slider-handle-ring-color: #10b98130;
}
.slider-marker-horizontal.slider-marker:not(.slider-marker-normal) {
  @apply absolute top-0 min-w-[2px] max-w-[2px] min-h-[10px] max-h-[10px] bg-[#e3b3b5];
}
.slider-value.slider-value-horizontal.slider-value-large {
  display: none;
}
</style>
